import sample_1 from './100_19422.jpg';

export const basicsRegularFitImpressions = {
    sample_1,
};
